// extracted by mini-css-extract-plugin
export default {"custom-scrollbar":"header_custom-scrollbar__zE-QU","avatar-with-photo":"header_avatar-with-photo__gRKdY","avatar-without-photo":"header_avatar-without-photo__xkUNA"};